import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
import { isFrameSuitableForPullOutInterior } from '../../utils/slidingDoorUtils';
export class PlatsaPullOutInteriorValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'PlatsaPullOutInteriorValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (this.coreApi.entities.isProductType(entity, ProductType.PLATSA_WIRE_BASKET_ASM) &&
            !isFrameSuitableForPullOutInterior(snapActionCandidate.host, this.coreApi)) {
            return this.validationFail('Cant add pull out interiors to this frame');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=PlatsaPullOutInteriorValidation.js.map